import React from 'react'
import { IconContainer } from './styles'
import { IconName, Icons } from '..'

interface IconComponentProps {
  name: IconName
  iconsize?: number
  height?: number
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const IconComponent: React.FC<IconComponentProps> = props => {
  const { name, iconsize, height, onClick, ...otherProps } = props
  const Icon = Icons[name]

  return (
    <>
      {Icon && (
        <IconContainer iconsize={iconsize} iconHeight={height} onClick={onClick}>
          <Icon {...otherProps} data-automation={`icon-exporter-${name}`} data-testid={name} />
        </IconContainer>
      )}
    </>
  )
}
